import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { SwitchButton, TabItems } from '../../../../../baseComponents/Button/SwitchButton'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { useState } from 'react'
import BaseScreenTableInner from '../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { ProductSellOrderComponentTy, ProductSellTypesInversedKeys } from './types'
import TableProductQuoteOrdersConnect from './TableProductQuoteOrders'
import NullComponent from '../../../../../baseComponents/NullComponent'
import TableProductSellOrdersConnect from './TableProductSellOrders'
import TableProductSellDeliveryNotesConnect from './TableProductSellDeliveryNotes'
import TableProductSellInvoicesConnect from './TableProductSellInvoices'
import TableProductWorkSheets from './TableProductWorkSheets'
import './sellsProduct.sass'
interface SellsProductProps extends ComponentWithPermissions {
    basicData: any | null
}

const SellsProduct: React.FC<SellsProductProps> = ({ basicData, userPermissions }) => {
    const { typeSell, setTypeSell } = useSellsProductLogic()

    basicData['typeSell'] = typeSell
    basicData['setTypeSell'] = setTypeSell
    const dictProductSellTy: ProductSellOrderComponentTy = {
        0: {
            TableComponent: TableProductQuoteOrdersConnect,
            extraWhereParams: {
                '$or': {
                    'Product.ProductId': basicData?.id,
                    'QuoteOrderProduct.ProductId': basicData?.id
                }
            },
        },
        1: {
            TableComponent: TableProductSellOrdersConnect,
            extraWhereParams: {
                '$or': {
                    'Product.ProductId': basicData?.id,
                    'SellOrderProduct.ProductId': basicData?.id
                }
            },
        },
        2: {
            TableComponent: TableProductSellDeliveryNotesConnect,
            extraWhereParams: {
                '$or': {
                    'Product.ProductId': basicData?.id,
                    'SellDeliveryNoteProduct.ProductId': basicData?.id
                }
            },
        },
        3: {
            TableComponent: TableProductSellInvoicesConnect,
            extraWhereParams: {
                '$or': {
                    'Product.ProductId': basicData?.id,
                    'SellInvoiceProduct.ProductId': basicData?.id
                }
            },
        },
        4: {
            TableComponent: TableProductWorkSheets,
            extraWhereParams: {
                '$or': {
                    'Product.ProductId': basicData?.id,
                    'WorkSheetProduct.ProductId': basicData?.id
                }
            },
        }
    }
    const pageData = {
        title: '',
        newText: '',
    }
    return (
        <BaseScreenTableInner className='single_product_orders' TableComponent={dictProductSellTy[typeSell].TableComponent} pageData={pageData} userPermissions={userPermissions} extraWhereParams={dictProductSellTy[typeSell].extraWhereParams} basicData={basicData} RightHeader={RightHeaderCustomerSellOrder} CreateModalComponent={NullComponent} />
    )
}


const useSellsProductLogic = () => {
    const [typeSell, setTypeSell] = useState<ProductSellTypesInversedKeys>(0)

    return { typeSell, setTypeSell }
}

interface RightHeaderCustomerSellOrderProps extends ModalEditComponentProps { }

const RightHeaderCustomerSellOrder: React.FC<RightHeaderCustomerSellOrderProps> = ({ basicData }) => {
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'quotes'}>Presupuestos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'sellOrders'}>Pedidos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'deliveryNotes'}>Albaranes</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'invoices'}>Facturas</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'workingSheets'}>Hojas de trabajo</TwinTrans>
        },
    ]
    return (
        <SwitchButton className='mr-auto' onClick={(val) => basicData?.setTypeSell(val as any)} active={basicData?.typeSell} items={items} />
    )
}


export default SellsProduct